import ApiPost from '../../../../../api-controller-mod/api-serv/post-api/postApi';
import ApiPut from '../../../../../api-controller-mod/api-serv/put-api/putApi';
import { UploadMediaFormData } from '../../../../../component-controller-mod/component-serv/texteditor-fs-cp/upload-media-overlay/ts/uploadMediaOverlay';
import { API_ENDPOINTS } from '../../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider';

// ─── API Types ────────────────────────────────────────────────────────────────

export interface ApiMediaItem {
  id:          number;
  uuid:        string;
  name:        string;
  alt:         string | null;
  description: string | null;
  type:        'IMAGE' | 'VIDEO';
  mimeType:    string;
  size:        number;
  url:         string;
  storagePath: string;
  folderId:    string;
  status:      string;
  uploadedBy:  string;
  createdAt:   string;
  updatedAt:   string;
}

// ─── Cookie helper ────────────────────────────────────────────────────────────

export function getCookie(name: string): string {
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : '';
}

// ─── API calls ────────────────────────────────────────────────────────────────

export async function uploadMediaApi(data: UploadMediaFormData): Promise<void> {
  const userUuid = getCookie('userUuid');
  const file     = data.files[0];

  const formData = new FormData();
  formData.append('file',        file);
  formData.append('type',        'IMAGE');
  formData.append('filename',    data.fileName);
  formData.append('alt',         data.altText ?? '');
  formData.append('description', data.description ?? '');

  await ApiPost(`${API_ENDPOINTS.UPLOAD_MEDIA}?userUuid=${userUuid}`, formData);
}

export async function deleteMediaApi(uuid: string): Promise<void> {
  if (!uuid) throw new Error('uuid is empty');
  await ApiPut(`${API_ENDPOINTS.DELETE_MEDIA}?mediaUuid=${uuid}`);
}

export async function editMediaFileApi(uuid: string, file: File, description?: string): Promise<void> {
  if (!uuid) throw new Error('uuid is empty');

  const formData = new FormData();
  formData.append('file',        file);
  formData.append('description', description ?? '');

  await ApiPut(`${API_ENDPOINTS.EDIT_MEDIA_FILE}?mediaUuid=${uuid}`, formData);
}

export async function editMediaTextApi(uuid: string, name: string, alt: string, description: string): Promise<void> {
  if (!uuid) throw new Error('uuid is empty');
  await ApiPut(`${API_ENDPOINTS.EDIT_MEDIA}?mediaUuid=${uuid}`, { name, alt, description });
}